export default __webpack_public_path__ + "static/media/gmail.5f30c93b.png";